export default "__VITE_ASSET__iU$_4F1___"